import { createSlice } from "@reduxjs/toolkit";
import {
  getSeventhFlow,
  createSeventhFlow,
  updateSeventhFlow,
  deleteSeventhFlow,
  clearLocalActiveSeventhFlow
} from './actions';

export const initialState = {
  seventhFlow: { 
    id: '', 
    phone: '', 
    email: '', 
    prompt: '', 
    updated_at: '' 
  },
  loading: false
};

const slice = createSlice({
  name: 'seventhFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getSeventhFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSeventhFlow.fulfilled, (state, action) => {
        const { seventh_flow } = action.payload;
        const seventhFlow = { ...state.seventhFlow, ...seventh_flow };
        
        state.loading = false;
        state.seventhFlow = seventhFlow;
      })
      .addCase(getSeventhFlow.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createSeventhFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSeventhFlow.fulfilled, (state, action) => {
        const { seventh_flow } = action.payload;
        
        state.loading = false;
        state.seventhFlow = seventh_flow;       
      })
      .addCase(createSeventhFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateSeventhFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSeventhFlow.fulfilled, (state, action) => {
        const { status, seventh_flow } = action.payload;
        const updatedSeventhFlow = { ...state.seventhFlow, ...seventh_flow };
        
        state.loading = false;
        if (status === 204) state.seventhFlow = updatedSeventhFlow;       
      })
      .addCase(updateSeventhFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteSeventhFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSeventhFlow.fulfilled, (state, action) => {
        const { status } = action.payload;
        
        state.loading = false;
        if (status === 204) state.seventhFlow = initialState.seventhFlow;       
      })
      .addCase(deleteSeventhFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveSeventhFlow, state => {
        state.seventhFlow = initialState.seventhFlow;
      })
  }
})

export default slice.reducer;